import { CustomComponentProps } from "utils/types/general.types";

export type PollItemProps = CustomComponentProps & {
    percent: number;
    option?: string;
};

const TextPollItem = ({ percent, option, className, style }: PollItemProps) => {
    return (
        <div
            className={`text-poll-item relative ${className} flex ${option ? "justify-between" : "justify-center"} items-center`}
            style={style}
        >
            <div className="text-poll-bg absolute"></div>
            <div
                className="text-poll-fg absolute"
                style={{ width: `${percent}%` }}
            ></div>
            {option ? <p className="momeento-p">{option}</p> : ""}
            <p className="momeento-p">{Math.round(percent)}%</p>
        </div>
    );
};

export default TextPollItem;
